import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import { DropdownMixin } from './dropdownMixin.js';
import { KeyboardClickable } from './KeyboardClickable.tsx';
import { Svg } from './Svg.js';
import { getCsrfToken } from '../utils/getCsrfToken.js';
import { toggleSignInOverlay } from '../general/module/toggleSigninOverlay';
import { addFavoritesToLocalStorage, getFavList } from '../favorites/favoritesStorage';
import { isEmailAddress } from '../utils/emailUtils.ts';
import { isLoggedInOrRemembered } from '../utils/isLoggedIn.ts';

export const FAVORITES_STYLE = {
    remindMe: 'remindMe',
    project: 'project',
    heart: 'heart',
};

export const AddToProjectFavoritesWidget = createReactClass({
    propTypes: {
        projectId: PropTypes.number.isRequired,
        isEligibleForFunding: PropTypes.bool.isRequired,
        initFavStatus: PropTypes.bool,
        userId: PropTypes.number,
        buttonText: PropTypes.string,
        buttonClass: PropTypes.string,
        displayStyle: PropTypes.string,
        favoritesStyle: PropTypes.string,
        handleRemoveFavorite: PropTypes.func,
        alwaysShowFavoritesWidget: PropTypes.bool,

    },

    favoritesLinkTimeout: null,

    mixins: [PureRenderMixin, DropdownMixin],

    getDefaultProps: function () {
        return {
            buttonText: 'Remind me about this project',
            buttonClass: 'js-test-save-v0',
            displayStyle: '',
            favoritesStyle: FAVORITES_STYLE.remindMe,
            initFavStatus: false,
            alwaysShowFavoritesWidget: false,
        };
    },

    getInitialState: function () {
        return {
            userId: this.props.userId,
            favStatus: this.props.initFavStatus,
            emailInput: '',
            loading: false,
            success: false,
            closeLightbox: false,
            showFavoritesLink: false,
        };
    },

    componentDidUpdate() {
        // on mobile, the email contact widget confuses the keyboard autofill, so hide it
        if (this.state.isOpen) {
            $('#email-contact-sign-up-widget').hide();
        } else {
            $('#email-contact-sign-up-widget').show();
        }
    },

    onEmailReminderInputChange: function () {
        this.setState({
            emailInput: event.target.value,
        });
    },

    componentDidMount: function () {
        // two widgets appear on the project page, so these listeners and callbacks ensure that they stay in sync
        window['addToProjectFavoritesCallback' + this.props.projectId] = this.handleCallback;
        const component = this;

        $(window).on('signoutTriggered.' + this.props.displayStyle + this.props.projectId, function () {
            component.setState({
                userId: null,
                loading: false,
                favStatus: false,
                success: false,
                closeLightbox: true,
            });
        });

        // after signin, updateFavoritesStorage is triggered
        $(document).on('updateFavoritesStorage.' + component.props.displayStyle + component.props.projectId, function () {
            // wait for setupUserCookies to finish before updating each favorite marker on the page
            setTimeout(function () { component.getFavStatusFromLocalStorage(); }, 100);
        });

        component.getFavStatusFromLocalStorage();
    },

    getFavStatusFromLocalStorage() {
        const component = this;
        $.when(getFavList('favProposalIds')).then(function (favList) {
            const isAFavorite = (favList && favList.includes(component.props.projectId));
            component.updateMarkerBasedOnFavorites(isAFavorite);
        });
    },

    updateMarkerBasedOnFavorites(isAFavorite) {
        this.setState({
            userId: window.userId,
            email: '',
            loading: false,
            favStatus: isAFavorite,
            success: false,
        });
    },

    componentWillUnmount: function () {
        $(window).off('signoutTriggered.' + this.props.displayStyle + this.props.projectId);
        $(document).off('updateFavoritesStorage.' + this.props.displayStyle + this.props.projectId);
        clearTimeout(this.favoritesLinkTimeout);
    },

    isTimely: function () {
        return (isLoggedInOrRemembered()) || (userObj && typeof userObj.timestamp !== 'undefined' && (parseInt(userObj.timestamp) > ((new Date()).getTime() - (2 * 24 * 60 * 60 * 1000))));
    },

    addToProjectFavoritesUpdate: function (response) {
        if (response.data.success) {
            const newUserId = (this.state.userId) ? this.state.userId : window.userId;
            this.setState({
                userId: newUserId,
                loading: false,
                favStatus: response.data.cpActive,
                success: true,
                showFavoritesLink: true,
                message: '',
            });
            this.favoritesLinkTimeout = setTimeout(() => {
                this.setState({
                    showFavoritesLink: false,
                });
            }, 5000);
            if (!response.data.cpActive && this.props.handleRemoveFavorite) {
                this.props.handleRemoveFavorite(response.data);
            }
        } else if (response.data.signinRequired) {
            const { active, email, message } = response.data;
            this.setState({
                loading: false,
                success: false,
                message,
            });
            this.toggleOpen();

            // Register a handler to complete favoriting after signin
            // I think this will only work if the user signs in with a PW on the same page.
            // An email link will load in a separate tab, and therefore not trigger this.
            // I'm not sure it's worth trying to handle that, though.
            $(window).one('signinTriggered', () => {
                this.submitProjectFavorites(active, email);
            });
            toggleSignInOverlay(null, true, { user: { username: email } });
        } else if (response.data.emailRequired) {
            this.setState({
                userId: null,
                email: '',
                loading: false,
                favStatus: response.data.cpActive,
                success: false,
                message: 'Please enter your email address and try again.',
            });
            this.toggleOpen();
        } else if (response.data.message) {
            this.setState({
                loading: false,
                favStatus: response.data.cpActive,
                success: false,
                message: response.data.message,
            });
        } else {
            this.setState({
                loading: false,
                favStatus: response.data.cpActive,
                success: false,
                message: 'Woops, we encountered an error. Please try again later.',
            });
        }
    },

    handleCallback: function (response) {
        addFavoritesToLocalStorage(response);
        setUpUserCookies();
        showSignOutLink();
        this.addToProjectFavoritesUpdate(response);
    },

    saveProjectFavorites: function (event) {
        if (this.state.email || (this.isTimely() && this.state.userId)) {
            const toggleFavStatus = !this.state.favStatus;
            this.setState({ loading: true, favStatus: toggleFavStatus });
            this.submitProjectFavorites(toggleFavStatus, this.state.email);
        }
        this.toggleOpen();
    },

    submitProjectFavorites: function (active, email) {
        // TODO:  how should the verify parameter be set?
        let urlString = secureBaseURL + 'common/wishlist_update.html?proposalId=' + this.props.projectId +
            '&callback=addToProjectFavoritesCallback' + this.props.projectId +
            '&action=add' +
            '&active=' + active +
            '&submitted=true' +
            '&' + csrfTokenParameterName + '=' + getCsrfToken();
        if (email) {
            urlString += '&email=' + email;
        }
        const e = document.createElement('script');
        e.src = urlString;
        e.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(e);

        if (typeof pageName !== 'undefined' && pageName != '') {
            dcAnalytics.trackEventGA([pageName, 'Link', 'Add to campaign']);
        }
        this.setState({ message: '' });
    },

    addProjectFavoritesEmail: function (event) {
        const email = this.state.emailInput;
        if (email && isEmailAddress(email)) {
            const toggleFavStatus = !this.state.favStatus;
            this.setState({ email, favStatus: toggleFavStatus });
            this.submitProjectFavorites(toggleFavStatus, email);
            this.toggleOpen();
        } else {
            alert('Your email address is missing or invalid.');
        }
    },

    removeFavoritesLink: function () {
        this.setState({ showFavoritesLink: false });
    },

    cancelFavoritesLinkTimeout: function () {
        clearTimeout(this.favoritesLinkTimeout);
    },

    getDropdownContent: function () {
        const props = this.props;
        const state = this.state;

        const autoCompleteStyle = window.isMobileDevice ? 'email' : 'off';

        if (state.isOpen && (!this.isTimely() || (!state.userId && !state.email))) {
            if (props.favoritesStyle != FAVORITES_STYLE.remindMe) {
                let promptPosition = (this.props.favoritesStyle == FAVORITES_STYLE.project) ? 'bottom' : '';
                if (!promptPosition) {
                    const offsetTop = this.instance.getBoundingClientRect().top;
                    if (offsetTop < 200) {
                        promptPosition = 'bottom';
                    }
                }
                return (
                    <div className={`email-prompt form-redux ${promptPosition}`}>
                        <h3>Enter your email to get updates on this project.</h3>
                        <div className="input-holder full-width">
                            <label htmlFor={`favorite-project-email-${this.props.projectId}`}>Email address</label>
                            <input id={`favorite-project-email-${this.props.projectId}`} onChange={this.onEmailReminderInputChange} className="add-to-project-favorites-email"
                                type="email" name="email" autoComplete={autoCompleteStyle} />
                        </div>
                        <KeyboardClickable>
                            <div tabIndex={0} role="button" className="add-to-project-favorites-button button-primary small full-width"
                                onClick={this.addProjectFavoritesEmail}>Get updates</div>
                        </KeyboardClickable>
                        <p className="message" dangerouslySetInnerHTML={{ __html: state.message }}></p>
                    </div>
                );
            } else {
                return (
                    <div className="email-prompt form-redux">
                        <div className="input-holder full-width">
                            <input onChange={this.onEmailReminderInputChange} className="add-to-project-favorites-email"
                                type="email" name="email" placeholder="email" autoComplete={autoCompleteStyle}/>
                        </div>
                        <KeyboardClickable>
                            <div tabIndex={0} role="button" className="add-to-project-favorites-button button-primary small full-width"
                                onClick={this.addProjectFavoritesEmail}>Follow</div>
                        </KeyboardClickable>
                        <p className="message" dangerouslySetInnerHTML={{ __html: state.message }}></p>
                    </div>
                );
            }
        } else if (state.message) {
            return (<p className="message" dangerouslySetInnerHTML={{ __html: state.message }}></p>);
        }

        return null;
    },

    getSaveForLater: function () {
        const props = this.props;

        if (!props.isEligibleForFunding) {
            return null;
        }

        const dropdownContent = this.getDropdownContent();
        const openStyle = {
            display: dropdownContent ? 'block' : 'none',
        };

        return (
            <div className={'button-secondary small js-save ' + this.props.buttonClass}>
                <div role="button" onClick={this.saveProjectFavorites} className="js-click-on-enter" tabIndex="0">
                    <HeartIcon favStatus={this.state.favStatus} />
                    <HeartText favStatus={this.state.favStatus} buttonText={this.props.buttonText} />
                </div>
                <div className="subnav campaign-popup favorites-popup" style={openStyle}>
                    {dropdownContent}
                </div>
            </div>
        );
    },

    getFavoritesMarker() {
        if (!this.props.isEligibleForFunding && !this.props.alwaysShowFavoritesWidget) {
            return null;
        }

        const saved = ((this.state.favStatus) ? ' saved' : '');
        let textLabel = '';
        if (this.props.favoritesStyle == FAVORITES_STYLE.project) {
            if (this.state.favStatus) {
                textLabel = <span className="favorite-text">Following</span>;
            } else {
                textLabel = <span className="favorite-text">Follow project for updates</span>;
            }
        }

        return (
            <div className="add-favorite" ref={(el) => this.instance = el }>
                <button aria-label="Follow for updates" onClick={this.saveProjectFavorites} className={`js-click-on-enter favorite-marker ${saved}`} role="button" tabIndex="0">
                    <HeartIcon favStatus={this.state.favStatus} />
                    {textLabel}
                </button>
                {this.getDropdownContent()}
            </div>
        );
    },

    render: function () {
        if (this.props.favoritesStyle != FAVORITES_STYLE.remindMe) {
            return (this.getFavoritesMarker());
        } else {
            return (this.getSaveForLater());
        }
    },
});

const HeartIcon = ({ favStatus }) => {
    const saved = ((favStatus) ? ' saved' : '');
    return (
        <Svg icon="bookmark" attributes={{ role: 'presentation' }} additionalClasses={saved}/>
    );
};
HeartIcon.propTypes = {
    favStatus: PropTypes.bool.isRequired,
};

const HeartText = ({ favStatus, buttonText }) => {
    const completedText = ((buttonText === 'Save for later') ? 'Saved' : 'Reminder sent');
    const save = ((favStatus) ? completedText : (buttonText));
    return (
        <span>{save}</span>
    );
};
HeartText.propTypes = {
    favStatus: PropTypes.bool.isRequired,
    buttonText: PropTypes.string,
};
